import { LocationExtra, LocationList, LocationShort } from '@libs/models/locations';
import { request } from '../../request';

export async function getOrgLocations(): Promise<{ data: LocationList[]; total: number }> {
  const response = await request.get<{ data: LocationList[]; total: number }>('/v2/settings/locations');
  return response.data;
}

export async function getLocationsSimple(): Promise<{ data: LocationShort[]; total: number }> {
  const response = await request.get<{ data: LocationShort[]; total: number }>('/v2/settings/locations');
  return response.data;
}

export async function getOrgLocation(locationId: string): Promise<LocationExtra> {
  const response = await request.get<LocationResponse>(`/v2/settings/locations/${locationId}`);
  const location = response.data;
  return {
    id: location.id,
    name: location.name,
    address: location.addressDetails,
    contact: {
      name: location.contact?.name || '',
      jobTitle: location.contact?.title || '',
      phonePrimary: location.contact?.phoneNumber || '',
      phoneSecondary: location.contact?.secondaryPhoneNumber || '',
      email: location.contact?.email || '',
    },
    isHeadquarters: location.isHQ,
    phoneNumber: location.contact.phoneNumber,
    status: location.status,
    timezone: location.timeZone,
    workWeekDayStart: location.workWeekDayStart,
    usedDepartmentNodes: location.usedDepartmentNodes,
    structure: location.structure,
    region: location.addressDetails.region,
    zipCode: location.addressDetails.zipCode,
  };
}
type LocationResponse = {
  id: string;
  name: string;
  addressDetails: {
    firstAddress: string;
    secondAddress: string;
    city: string;
    state: string;
    zipCode: string;
    region: string;
  };
  contact: {
    name: string;
    title: string;
    phoneNumber: string;
    secondaryPhoneNumber: string;
    email: string;
  };
  status: 'Active' | 'Deactivated';
  timeZone: string;
  workWeekDayStart: 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
  usedDepartmentNodes: string[];
  structure: LocationStructure[];
  isHQ: boolean;
};
type LocationStructure = {
  id: string;
  label: string;
  type: string;
  locationSpecific: boolean;
  parentId: string | null;
  children?: LocationStructure[];
};

export async function createOrgLocation(locationInfo: LocationExtra): Promise<void> {
  const response = await request.post('/v2/settings/locations', {
    name: locationInfo.name,
    addressDetails: locationInfo.address,
    phoneNumber: locationInfo.phoneNumber,
    contact: {
      email: locationInfo.contact.email,
      phoneNumber: locationInfo.contact.phonePrimary,
      secondaryPhoneNumber: locationInfo.contact.phoneSecondary,
      name: locationInfo.contact.name,
      title: locationInfo.contact.jobTitle,
    },
    status: locationInfo.status,
    timeZone: locationInfo.timezone,
    workWeekDayStart: locationInfo.workWeekDayStart,
    isHQ: locationInfo.isHeadquarters,
    usedDepartmentNodes: locationInfo.usedDepartmentNodes,
  });
}

export async function updateOrgLocation(id: string, locationInfo: LocationExtra): Promise<void> {
  const response = await request.patch(`/v2/settings/locations/${id}`, {
    name: locationInfo.name,
    addressDetails: locationInfo.address,
    phoneNumber: locationInfo.phoneNumber,
    contact: {
      email: locationInfo.contact.email,
      phoneNumber: locationInfo.contact.phonePrimary,
      secondaryPhoneNumber: locationInfo.contact.phoneSecondary,
      name: locationInfo.contact.name,
      title: locationInfo.contact.jobTitle,
    },
    status: locationInfo.status,
    timeZone: locationInfo.timezone,
    workWeekDayStart: locationInfo.workWeekDayStart,
    isHQ: locationInfo.isHeadquarters,
    usedDepartmentNodes: locationInfo.usedDepartmentNodes,
  });
}
